/**
 * Slimona motion layer (v4) — the two behaviours CSS alone cannot express.
 *
 * 1. Sections arrive once, as they enter the viewport, staggered by their order on screen.
 * 2. The header becomes a translucent material once the page has scrolled past it.
 *
 * Both are opt-out under prefers-reduced-motion, and both are pure transform/opacity work so the
 * compositor carries them. No library, no build step, nothing that blocks input.
 */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- 1. arrival ------------------------------------------------------------------------ */
  function armReveals() {
    if (reduced.matches || !('IntersectionObserver' in window)) return;

    var candidates = document.querySelectorAll(
      '[id^=shopify-section] > *:not(.header):not([class*=announcement])'
    );

    var targets = [];
    candidates.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.height < 160) return;                 // skip strips and chrome
      if (r.top < window.innerHeight * 0.9) return; // already on screen: never hide it
      el.setAttribute('data-reveal', 'armed');
      targets.push(el);
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, i) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          // A short stagger reads as one movement rather than several separate ones.
          window.setTimeout(function () {
            el.setAttribute('data-reveal', 'in');
          }, Math.min(i, 3) * 70);
          io.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.06 }
    );

    targets.forEach(function (el) { io.observe(el); });

    // Failsafe: whatever happens to the observer, nothing stays invisible.
    window.setTimeout(function () {
      targets.forEach(function (el) {
        if (el.getAttribute('data-reveal') !== 'in') el.setAttribute('data-reveal', 'in');
      });
    }, 1600);
  }

  /* ---- 2. header material ----------------------------------------------------------------- */
  function armHeader() {
    var header = document.querySelector('.header, header[class*=header]');
    if (!header) return;

    var ticking = false;
    function update() {
      header.setAttribute('data-scrolled', window.scrollY > 48 ? 'true' : 'false');
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }

  function start() {
    armReveals();
    armHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
